import { Route } from "react-router";
import { ProtectedRoute } from "./components";
import { CheckoutFailure, CheckoutSuccess } from "@/pages";
import React from "react";
import { permissionsAllowToAll } from "@/utils";

export const checkoutRoutes: React.ReactElement[] = [
  <Route
    key="success"
    path="success"
    element={
      <ProtectedRoute
        element={<CheckoutSuccess />}
        codes={permissionsAllowToAll}
      />
    }
  />,
  <Route
    key="failure"
    path="failure"
    element={
      <ProtectedRoute
        element={<CheckoutFailure />}
        codes={permissionsAllowToAll}
      />
    }
  />,
];
